const { Home, Dist, Order, Stat, Settings, Other, Login, FindPwd, BindGuide } = window.routers;

export { Home, Dist, Order, Stat, Settings,Other, Login, FindPwd, BindGuide };



// WEBPACK FOOTER //
// ./pages/.routers.js